import React, { useState, useEffect } from "react";
import GaugeChart from "react-gauge-chart";
import API from "../api.js";

const FearGreedMeter = () => {
  const [data, setData] = useState({
    value: "",
    value_classification: "",
  });

  useEffect(() => {
    API.get("/fng")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  const chartStyle = {
    width: "85vh",
  };

  return (
    <div className="feargreed-div">
      <h1 className="title">Today's Fear & Greed Meter</h1>
      <GaugeChart
        style={chartStyle}
        nrOfLevels={420}
        arcsLength={[0.4, 0.5, 0.5]}
        colors={["#EA4228", "#F5CD19", "#5BE12C"]}
        percent={parseInt(data.value) * 0.01}
      />
      <h1
        style={{
          color: parseInt(data.value) >= 50 ? "lightgreen" : "darkred",
        }}
      >
        {data.value_classification}
      </h1>
    </div>
  );
};

export default FearGreedMeter;
